<template>
  <div class="container">
    <div class="bg-img-box">
    <div class="bg-img" style=''>
    </div>
  </div>
    <div class="banner">
      <div class="w-1300">
        <div class="bannerimg">
          <div class="serch m-auto pl10 pr10">
            <div>
              <img src="../assets/svg/suosuo.svg" alt="" srcset="" style="width: 20px;height: 20px;margin-left: 6px;margin-top: 3px;">
            </div>
            <el-input v-model="serchName" placeholder="请输入关键字搜索">
              <!-- <template #prefix>
                <el-icon class="el-input__icon">
                  <search />
                </el-icon>
              </template> -->
            </el-input>
            <el-button type="primary"
              style="color: #fff;background-color: red;border: red; border-radius: 20px; width: 100px;"
              @click="searchfun">搜索</el-button>
          </div>
          <div class="carContent flex jc-a">
            <div class="car flex jc-a ai-c" @click="tabMenu(1)">
              <div class="flex jc-c ai-c">
                <img src="../assets/home/car5.png" class="carimg" />
              </div>
              <div class="fff lh-25">
                <p class="lnone">准考证打印平台</p>
                <p class="lintwo">准考证打印平台</p>
              </div>
            </div>
            <div class="car flex jc-a ai-c" @click="carfun(2)">
              <div class="flex jc-c ai-c">
                <img src="../assets/home/car3.png" class="carimg" />
              </div>
              <div class="fff lh-25">
                <p class="lnone">普通话水平测试</p>
                <p class="lintwo">网上报名系统</p>
              </div>
            </div>
            <div class="car flex jc-a ai-c" @click="tabMenu(2)">
              <div class="flex jc-c ai-c">
                <img src="../assets/home/car4.png" class="carimg" />
              </div>
              <div class="fff lh-25">
                <p class="lnone">成绩查询平台</p>
                <p class="lintwo">支持各类考试成绩查询</p>
              </div>
            </div>
            <div class="car flex jc-a ai-c" @click="tabMenu(3)">
              <div class="flex jc-c ai-c">
                <img src="../assets/home/car1.png" class="carimg" />
              </div>
              <div class="fff lh-25">
                <p class="lnone">守正创新·争做示范</p>
                <p class="lintwo">党的二十大精神学习专栏</p>
              </div>
            </div>
            <div class="car flex jc-a ai-c" @click="tabMenu(4)">
              <div class="flex jc-c ai-c">
                <img src="../assets/home/car2.png" class="carimg" />
              </div>
              <div class="fff lh-25 pr20">
                <p class="lnone" style="padding-left: 10px;">本院概况</p>
                <p class="lintwo" style="padding-left: 10px;">省内一流的考试研究中心</p>
              </div>
            </div>
          </div>
        </div>

        <div class="w-1300 flex">
          <div class="content">
            <div class="flex jc-b pt30 pb20">
              <div class="flex" style="margin-left: 30px;">
                <img src="../assets/svg/dt.svg"  style="width: 30px; height: 30px;"/>
                <div class="fs-22 ctext pl10 red">考试动态</div>
              </div>
              <div class="more red" style="margin-right: 37px;" @click="morefun(1)">MORE</div>
            </div>

            <div class="flex jc-b  title" v-for="i in dataNews">
              <div class="pl20 article fw-br" @click="details(i, 1)">
                [考试动态]{{ i.title }}
              </div>
              <div class="A199 time" style="    height: 56px;
    line-height: 56px;">{{filpublishDate(i.publishDate) }}</div>
            </div>

          </div>

          <div class="content ml30">

            <div class="flex jc-b pt30 pb20">
              <div class="flex" style="margin-left: 30px;">
                <img src="../assets/svg/gg.svg"  style="width: 30px; height: 30px;"/>
                <div class="fs-22 ctext pl10 red">通知公告</div>
              </div>
              <div class="more red" style="margin-right: 37px;" @click="morefun(2)">MORE</div>
            </div>

            <div class="flex jc-b   title " v-for="i in dataNotices" @click="details(i, 2)">
              <div class="pl20 article fw-br">
                [通知公告]{{ i.title }}
              </div>
              <div class="A199 fs-16 pr10 time" style="    height: 56px;
    line-height: 56px;">{{ filpublishDate(i.publishDate) }}</div>
            </div>
          </div>


        </div>
      </div>

    </div>
  </div>
</template>
<script setup>
import { ref, onBeforeMount, onMounted } from 'vue'
import { Calendar, Search } from '@element-plus/icons-vue'
import { useRouter } from "vue-router";
import store from '@/store';
import { contentlistAllNews, contentlistAllNotices } from '@/api/demo'
import { ElMessage, ElMessageBox } from 'element-plus'
const router = useRouter()

let list = ref([])

let dataNotices = ref([])
let dataNews = ref([])

let serchName = ref('')
onBeforeMount(() => { listup() })
onMounted(() => { console.log('3.-组件挂载到页面之后执行-------onMounted') })

const listup = () => {
  contentlistAllNotices({ pageNum: 1, pageSize: 10 }).then(res => {
    if (res.code == 100000) {
      dataNotices.value = res.data.list
    } else {
      ElMessage.error(res.description);
    }
  })
  contentlistAllNews({ pageNum: 1, pageSize: 10 }).then(res => {
    if (res.code == 100000) {
      dataNews.value = res.data.list
    } else {
      ElMessage.error(res.description);
    }
  })
}
const searchfun = () => {
  store.commit('updateSearchValue', serchName.value)
  router.push({ name: 'search', query: { title: 'search' } })


}
const filpublishDate = (t) => {
  if (t) {
    let obdata = t.split(' ')[0]
    return obdata
  }
}
const details = (t, y) => {
  if (t.outLink) {
    window.open(t.outLink)

  } else {
    router.push({ name: 'details', query: { id: t.id, homeType: y } })

  }
}
const morefun = (t) => {
  router.push({ name: 'homeMore',query:{homeType: t,} })
}
const carfun = (t) => {
  switch (t) {
    case 2:
      window.open('https://nbeeapth.nbedu.net.cn/')
      break;

    default:
      break;
  }
}
const tabMenu = (t) => {
  store.state.tabMenuList.map(v => {
    if (t == '1') {
      if (v.title == '准考证' || v.title == '准考证打印平台') {
        router.push({ name: 'adult', query: { fid: v.id, title: v.title } })
      }
    }else if(t == '2') {
      if (v.title == '成绩查询' || v.title == '成绩查询平台') {
        router.push({ name: 'adult', query: { fid: v.id, title: v.title } })
      }
    }else if(t == '3') {
      if (v.title == '守正创新·争做示范' || v.title == '守正创新') {
        router.push({ name: 'adult', query: { fid: v.id, title: v.title } })
      }
    }else if(t == '4') {
      if (v.title == '本院概况') {
        router.push({ name: 'adult', query: { fid: v.id, title: v.title } })
      }
    }
  })
}
</script>
<style>
.el-input__wrapper {
  padding-left: 3px !important;
}
</style>
<style lang="less" scoped>
.car:hover {
  border: 3px solid #fff;
  box-sizing: border-box;
  .carimg{
    padding-left: 7px;
  }
  .lnone{
    padding-right: 17px;
  }
  .lintwo{
    width: 97%;
    padding-right: 17px;
  }

}
.bg-img-box {
  width: 100%;
  height: 521px;
  overflow: hidden;
}

.bg-img {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  filter: blur(20px);
  transform: scale(1.5);
  background-position: 50%;
  background-image: url("../assets/home10/home10.png")
}

.bg-img::after {
  content: " ";
  display: block;
  width: 100%;
  height: 400rpx;
  background: rgba(17, 17, 17, .2);
  z-index: 1;
}
.lnone{
  // fs-16 pt26 pr20
  font-size: 16px;
  // padding-top: 18px;
  font-weight: bold;
  padding-right: 20px;
}
.lintwo{
  // fs-12 pr20
  font-size: 12px;
  padding-right: 20px;
  width: 100%;
}
/deep/ .el-input__wrapper {
  background: none;
  line-height: 50px;
  border-radius: 55px;
  box-shadow: none;
}

/deep/ .el-input__inner {
  //改文字
  font-size: 14px;
  color: #333;
}

.carContent {
  padding-top: 50px;
  cursor: pointer;
}

.car {
  width: 232px;
  height: 100px;
  background: rgba(255, 255, 255, 0.14);
  border-radius: 10px 10px 10px 10px;
  opacity: 1;
}

.carimg {
  width: 50px;
  height: 50px;
  padding-left: 10px;
}

.banner {
  // background-image: url('../assets/home.png');
  // background: linear-gradient(to right, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url('../assets/home10/home10.png');
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 520px;
  position: absolute;
  top: 137px;
  // background-size: cover;
  // backdrop-filter: blur(5px);
  // filter: blur(5px);
}

.content {
  width: 635px;
  height: 670px;
  border-radius: 10px 10px 10px 10px;
  opacity: 1;

  background-color: #fff;

  .ctext {
    width: 120px;
    height: 26px;
    font-size: 22px;
    font-family: Source Han Serif CN VF, Source Han Serif CN VF;
    font-weight: 800;
    // color: #000000;
    line-height: 26px;
  }

  .more {
    width: 42px;
    height: 17px;
    font-size: 14px;
    font-family: Helvetica LT, Helvetica LT;
    font-weight: bold;
    // color: #1967BC;
    line-height: 16px;
    cursor: pointer;
  }

  .article {
    font-size: 16px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    // width: 400px;
    width: 82%;
    height: 56px;
    line-height: 56px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    text-align: left;

  }
  .time{
    width: 18%;
    font-size: 16px;
    margin-left: 10px;
    text-align: right;
    padding-right: 20px;
  }
}

.time {
  font-size: 14px;
}
.title {
  width: 96%;
  margin-left: 10px;
}
.title:hover {
  background: #BB0606;
  border-radius: 10px 10px 10px 10px;
  color: #fff;

  .time {
    color: #fff;
  }
}

.serch {
  width: 680px;
  height: 54px;
  margin-top: 277px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 60px;
}

.bannerimg {
  background-image: url('../assets/home10/home10.png');

  height: 520px;
  width: 100%;
  overflow: hidden;


}

.demonstration {
  color: var(--el-text-color-secondary);
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.container {
  width: 100%;
  height: 1200px;
  padding-bottom: 100px;
  background-color: #FAFBFC;
}</style>
